import right_box from "../assets/right_box.png";
import left_circle from "../assets/left_circle.png";
import { features } from "../utils/static";
import { useContext } from "react";
import { AppContext } from "../context/context";

function Features() {
  const { setState } = useContext(AppContext);

  return (
    <div
      id="features"
      className="relative w-full flex flex-col items-center bg-teal text-white py-16 lg:pb-48 px-8 md:px-28 lg:px-8 gap-8 md:gap-20"
    >
      <img
        src={right_box}
        alt="right_box"
        className="absolute w-24 md:w-48 right-0 top-[-35px] md:top-[-70px]"
        onLoad={() => {
          setState((ps) => ({ ...ps, loadedImages: ps.loadedImages + 1 }));
        }}
      />

      <img
        src={left_circle}
        alt="left-circle"
        className="absolute w-20 md:w-36 left-0 bottom-0"
        onLoad={() => {
          setState((ps) => ({ ...ps, loadedImages: ps.loadedImages + 1 }));
        }}
      />

      <div className="w-full h-fit flex flex-col justify-center items-center gap-6">
        <h6 className="text-[22px] smd:text-[32px] md:text-[38px] xxl:text-[48px] font-semibold text-center">
          Smarter, Simpler, Better
        </h6>

        <p className="text-sm smd:text-base md:text-2xl font-semibold text-center max-w-[800px] text-white">
          SynapsivateHRM offers streamlined rostering, efficient HR management,
          seamless leave management, accurate attendance management and
          organized calendar & events functionalities.
        </p>
      </div>

      <div className="max-w-[1300px] llxl:max-w-full flex flex-wrap items-center justify-center gap-8 lg:gap-12">
        {features.map((feature, index) => (
          <div
            key={index}
            className="w-fit h-fit md:h-[200px] flex flex-col justify-center items-center gap-2 md:gap-8"
          >
            <div className="w-20 h-20 p-5 rounded-xl bg-purp flex justify-center items-center">
              {feature.icon}
            </div>

            <div className="w-full flex flex-col items-center gap-1 md:gap-4">
              <h1 className="text-lg md:text-2xl font-semibold">
                {feature.name}
              </h1>
              <p className="text-center text-sm md:text-base xl:text-[18px] max-w-[250px] md:max-w-[300px] text-white">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Features;
